import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FolderTree = ({ language, onFolderSelect, selectedFolder }) => {
  const [expandedFolders, setExpandedFolders] = useState(['root', 'clients', 'cases']);

  const folderStructure = {
    id: 'root',
    nameEn: 'All Documents',
    nameFr: 'Tous les documents',
    nameAr: 'جميع المستندات',
    children: [
      {
        id: 'clients',
        nameEn: 'Client Documents',
        nameFr: 'Documents clients',
        nameAr: 'مستندات العملاء',
        count: 156,
        children: [
          {
            id: 'client-contracts',
            nameEn: 'Contracts',
            nameFr: 'Contrats',
            nameAr: 'العقود',
            count: 45
          },
          {
            id: 'client-correspondence',
            nameEn: 'Correspondence',
            nameFr: 'Correspondance',
            nameAr: 'المراسلات',
            count: 78
          },
          {
            id: 'client-identification',
            nameEn: 'Identification Documents',
            nameFr: 'Documents d\'identité',
            nameAr: 'وثائق الهوية',
            count: 33
          }
        ]
      },
      {
        id: 'cases',
        nameEn: 'Case Files',
        nameFr: 'Dossiers judiciaires',
        nameAr: 'ملفات القضايا',
        count: 234,
        children: [
          {
            id: 'case-pleadings',
            nameEn: 'Pleadings',
            nameFr: 'Plaidoiries',
            nameAr: 'المرافعات',
            count: 89
          },
          {
            id: 'case-evidence',
            nameEn: 'Evidence',
            nameFr: 'Preuves',
            nameAr: 'الأدلة',
            count: 67
          },
          {
            id: 'case-judgments',
            nameEn: 'Judgments',
            nameFr: 'Jugements',
            nameAr: 'الأحكام',
            count: 45
          },
          {
            id: 'case-appeals',
            nameEn: 'Appeals',
            nameFr: 'Appels',
            nameAr: 'الاستئنافات',
            count: 33
          }
        ]
      },
      {
        id: 'templates',
        nameEn: 'Legal Templates',
        nameFr: 'Modèles juridiques',
        nameAr: 'النماذج القانونية',
        count: 45,
        children: [
          {
            id: 'template-contracts',
            nameEn: 'Contract Templates',
            nameFr: 'Modèles de contrats',
            nameAr: 'نماذج العقود',
            count: 15
          },
          {
            id: 'template-letters',
            nameEn: 'Letter Templates',
            nameFr: 'Modèles de lettres',
            nameAr: 'نماذج الرسائل',
            count: 20
          },
          {
            id: 'template-forms',
            nameEn: 'Legal Forms',
            nameFr: 'Formulaires juridiques',
            nameAr: 'النماذج القانونية',
            count: 10
          }
        ]
      },
      {
        id: 'invoices',
        nameEn: 'Invoices & Billing',
        nameFr: 'Factures et facturation',
        nameAr: 'الفواتير والمحاسبة',
        count: 89
      },
      {
        id: 'administrative',
        nameEn: 'Administrative',
        nameFr: 'Administratif',
        nameAr: 'الإدارية',
        count: 67
      }
    ]
  };

  const getName = (folder) => {
    if (language === 'fr') return folder?.nameFr;
    if (language === 'ar') return folder?.nameAr;
    return folder?.nameEn;
  };

  const toggleFolder = (folderId) => {
    setExpandedFolders(prev => 
      prev?.includes(folderId) 
        ? prev?.filter(id => id !== folderId)
        : [...prev, folderId]
    );
  };

  const renderFolder = (folder, level = 0) => {
    const isExpanded = expandedFolders?.includes(folder?.id);
    const hasChildren = folder?.children && folder?.children?.length > 0;
    const isSelected = selectedFolder === folder?.id;

    return (
      <div key={folder?.id}>
        <div
          className={`flex items-center gap-2 px-3 py-2 rounded-lg cursor-pointer transition-all duration-250 ${
            isSelected ? 'bg-primary text-primary-foreground' : 'hover:bg-muted'
          }`}
          style={{ paddingLeft: `${(level * 16) + 12}px` }}
          onClick={() => {
            if (hasChildren) {
              toggleFolder(folder?.id);
            }
            onFolderSelect(folder?.id);
          }}
        >
          {hasChildren && (
            <Icon 
              name={isExpanded ? 'ChevronDown' : 'ChevronRight'} 
              size={16}
              className="flex-shrink-0"
            />
          )}
          {!hasChildren && <div className="w-4" />}
          <Icon 
            name={hasChildren ? (isExpanded ? 'FolderOpen' : 'Folder') : 'FileText'} 
            size={18}
            className="flex-shrink-0"
          />
          <span className="text-sm font-medium flex-1 truncate">
            {getName(folder)}
          </span>
          {folder?.count !== undefined && (
            <span className="text-xs opacity-70 flex-shrink-0">
              {folder?.count}
            </span>
          )}
        </div>
        {hasChildren && isExpanded && (
          <div>
            {folder?.children?.map(child => renderFolder(child, level + 1))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="h-full overflow-y-auto">
      {renderFolder(folderStructure)}
    </div>
  );
};

export default FolderTree;